import { render } from "./permission.vue?vue&type=template&id=0f13b2af"
import script from "./permission.vue?vue&type=script&lang=js"
export * from "./permission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__